
        var normalize = require("../../../node_modules/san-loader/lib/runtime/normalize.js");
        require('/Users/duanhong/Source/Lean/LeanPM/webapps/shared/src/components/BatchUpload/BatchUpload.san?lang=css&san=&type=style&index=0');
var injectStyles = [];

        var template = require('./BatchUpload.html');
        
        var script = require('./BatchUpload.ts').default;
        module.exports = require('./BatchUpload.ts');
    
        module.exports.default = normalize(script, template, injectStyles);
        /* san-hmr component */
    